import styled from 'styled-components/native'

export const ViewHorizontal = styled.View`
    flex-direction: row;
    align-items: center;
    padding: 1rem 0rem;
    justify-content: ${({ justifyContent }) => (justifyContent ? justifyContent : "space-between")};
`;

/* Quebra linha no celular: a busca (340px) mais os dois botões não cabem em
   360px de tela, e os botões saíam pela borda direita. */
export const Row = styled.View`
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: ${({ gap }) => (gap ? gap : 0)};
`;

export const ViewTable = styled.View`
    background-color: #FFFFFF;
    border-width: 1px;
    border-color: #E5E7EB;
    border-radius: 12px;
    padding: 16px;
`;

export const ContainerScroll = styled.ScrollView.attrs({
    showsVerticalScrollIndicator: true,
    contentContainerStyle: {
        paddingHorizontal: "1rem",
    },
})` 
  `;